import { CollectedRef } from './collected-ref';
import { StatSenderInterface } from './stat-sender-interface';
import { UserStatEntryType } from '../../stat/UserStatEntryType';

export class CollectedRefsFactSender {
    private readonly sender: StatSenderInterface;
    private readonly refsCollection: Array<CollectedRef>;
    constructor(refsCollection: Array<CollectedRef>, sender: StatSenderInterface) {
        this.refsCollection = refsCollection;
        this.sender = sender;
    }

    public send(): void {
        try {
            if (!Array.isArray(this.refsCollection)) {
                throw new Error('ref collection is not array');
            }

            this.refsCollection.forEach(async(ref: CollectedRef) => {
                this.sender.sendEvent(
                    UserStatEntryType.marketing_click_referral_link,
                    1,
                    [ref.ts],
                    [ref.query],
                    null
                );
            });
        } catch (exception) {
            window.Sentry.captureException(exception);
            console.error('Failed to send collected refs facts');
        }
    }
}
